import { render, staticRenderFns } from "./AccentButton.vue?vue&type=template&id=a4443018&"
import script from "./AccentButton.vue?vue&type=script&lang=js&"
export * from "./AccentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports